export default {
  data: {
    nameFlag: false, // 嘉怡
    isSctcm: false, // 四川中医
    isYntcm: false, // 云南
    isGuangAn: false // 广安
  },
  created() {
    this.nameFlag = this._setHost('jiayi.teleicu.cn')
    this.isSctcm =  this._setHost('sctcm.teleicu.cn')
    this.isYntcm = this._setHost('yntcm.teleicu.cn')
    this.isGuangAn = this._setHost('ga.teleicu.cn')
    this.isZN = this._setHost('xiuyu.ccmqc.com') || true
  },
  methods: {
    _setHost(host) {
      return window.location.host === host
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/host.js